<template>
  <el-select v-model="country" @change="getCty"  clearable placeholder="请选择国家" size="small">
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.zhname"
      :value="item.zhname"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "@/http/api";
export default {
  name: "country",
  props: {
    countrys: { String }
  },
  data() {
    return {
      options: [], 
      country: this.countrys
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init(){
      let that=this
      httpApi.listParams({ params: { type: "sys_country",enable:"1" } }).then(res => {
         that.options = res.data.data;
      });
    }
  },
  created() {
    this.init()
  },
  watch: {
    countrys: function(newVal) {
      this.country = newVal;
    }
  }
};
</script>

<style>
/* .el-select-dropdown{
  min-width: 150px !important;
} */
</style>